import * as React from "react";
import "./styles.scss"
import {TAB_NAMES, ToolBarTabs} from "../ToolBarTabs";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {InputAddon, TextInput, useDebounce} from "@vebox/etui-core";
import {Display} from "../../../components/Display";
import {PAGES} from "../../pages/MainContentPage";
import {INPUT_BORDER_BOX_WITH_MARGIN} from "./utils";


interface ToolBarProps {
}

export const ToolBar: React.FC<ToolBarProps> = () => {

    const {
        tabs,
        currentTab,
        changeTab,
        changeRegisterFilterText,
        changeHistoryFilterText,
        historyFilterText,
        registerFilterText,
        AppTranslations,
        currentPage,
        getTabText
    } = React.useContext(
        ReadAndWriteContext);

    const [showToolbarTabs, setShowToolbarTabs] = React.useState<boolean>(false);
    const [filterTextDebounced, setFilterTextDebounced] = useDebounce<string>("", 200);
    const [filterText, setFilterText] = React.useState<string>(
        currentTab === TAB_NAMES.CURRENT ? registerFilterText : historyFilterText);

    const onTabSelected = (tabName: TAB_NAMES) => () => {
        changeTab(tabName);
    }

    const changeFilterText = (text: string) => {
        setFilterText(text);
        setFilterTextDebounced(text);
    };

    const handleOnTextInputChange = (event: React.ChangeEvent<HTMLInputElement>) => changeFilterText(
        event.target.value);

    const handleOnCancel = () => changeFilterText("");

    React.useEffect(() => {
        if (currentTab === TAB_NAMES.CURRENT) {
            changeRegisterFilterText(filterText);
        } else if (currentTab === TAB_NAMES.HISTORY) {
            changeHistoryFilterText(filterText);
        }
    }, [filterTextDebounced]);

    React.useEffect(() => {
        changeFilterText(currentTab === TAB_NAMES.CURRENT ? registerFilterText : historyFilterText);
    }, [currentTab]);

    React.useEffect(() => {
        setShowToolbarTabs([PAGES.UPDATING, PAGES.SETTINGS].includes(currentPage))
    }, [currentPage]);

    return (
        <div className={"toolbar-container"}>
            <TextInput
                label={AppTranslations.filters.filterBy}
                value={filterText}
                onChange={handleOnTextInputChange}
                styles={INPUT_BORDER_BOX_WITH_MARGIN}
                autoComplete={"off"}
                endInputAddon={
                    <InputAddon position="end">
                        {filterText !== "" && <span
                            className="material-icons clickable cancel-filter-icon"
                            onClick={handleOnCancel}
                        >clear</span>}
                    </InputAddon>}
            />
            <Display isVisible={showToolbarTabs}>
            <ToolBarTabs
                currentTab={currentTab}
                tabsNames={tabs}
                onTabSelected={onTabSelected}
                getTabText={getTabText}
            />
        </Display>
        </div>
    );
};